/**
 * state.ts — глобальное состояние, константы, DOM-ссылки
 * Проект: TorgiRT (shared — все витрины)
 */

import type { State, Product, CartConfig } from './types';

export const ITEMS_PER_PAGE = 15;

/* ── Dynamic storefront paths (read from window.CART_CONFIG set by footer.php) ── */
const _cfg: Partial<CartConfig> = window.CART_CONFIG || {};
export const CART_STORAGE_KEY: string = _cfg.storefront
  ? "torgirt-" + _cfg.storefront + "-cart"
  : "torgirt-i-cart";
export const VIEW_MODE_KEY = "torgirt-view-mode";
const _refCode = _cfg.refCode || '';
export const BASE_PATH: string = _cfg.basePath
  ? _cfg.basePath + (_refCode ? '/' + _refCode : '')
  : "/i";

/* ── Animation timing constants (mirror CSS tokens) ── */
export const UI_TIMING = Object.freeze({
  fast:         150,
  ui:           220,
  panel:        260,
  slow:         300,
  accent:       600,
  hintCleanup:  700,
  scrollSettle: 450,
  tapFeedback:  120,
});

export const state: State = {
  catalogData: { categories: [] },
  products: [],
  pagination: { total: 0, page: 1, perPage: ITEMS_PER_PAGE, totalPages: 1 },
  filterValues: {},
  cart: [],
  cartOpen: false,
  searchQuery: "",
  currentPage: 1,
  viewMode: localStorage.getItem(VIEW_MODE_KEY) || "grid",
  selectedProduct: null,
  currentImageIndex: 0,
  productPageImageIndex: 0,
  catalogOpen: false,
  expandedCategories: new Set(),
  selectedCategory: null,
  selectedSubcategory: null,
  breadcrumbPath: null,
  currentFilters: [],
  activeFilters: {},
  sortBy: "",
  searchMode: "strict",
  imageViewerOpen: false,
  priceMin: "",
  priceMax: "",
  stockOnly: false,
  favoritesOnly: false,
  productPage: null,
  ssrHydrated: false,
  loadError: false,
  syncFailed: false,
};

export const productLookup: Map<string, Product> = new Map();
export const filterCodeToName: Map<string, string> = new Map();

export let searchDictionary: string[] = [];

/** Установить словарь (вызывается из catalog.js после buildSearchDictionary) */
export function setSearchDictionary(dict: string[]): void {
  searchDictionary = dict;
}

export const refs: Record<string, HTMLElement | null> = {
  app: document.getElementById("app"),
  cartBadge: document.getElementById("cart-badge"),
  cartSummary: document.getElementById("cart-summary"),
  cartItemsWrap: document.getElementById("cart-items-wrap"),
  cartItems: document.getElementById("cart-items"),
  catalogWrap: document.getElementById("catalog-wrap"),
  catalogDropdown: document.getElementById("catalog-dropdown"),
  breadcrumb: document.getElementById("breadcrumb"),
  filtersBar: document.getElementById("filters-bar"),
  products: document.getElementById("products"),
  pagination: document.getElementById("pagination"),
  modal: document.getElementById("product-modal"),
  searchInput: document.getElementById("search-input"),
  cartSummaryFloating: document.getElementById("cart-summary-floating"),
  cartSummaryFloatingText: document.getElementById("cart-summary-floating-text"),
  productsCount: document.getElementById("products-count"),
};
